module.exports = __webpack_public_path__ + "assets/img/komanda.17221565.webp";